export default function formatHotelRoomName(room, bed) {
  if (!room?.name) return '';
  return `${room?.name} ${bed?.name ? `(${bed?.name})` : ''}`;
}
